import { Flex } from "@public/layouts/Layouts.styles";
import styled from "styled-components";

export const MetricCardEmptyStateRoot = styled(Flex)`
  flex: 1;
  padding-top: 2rem;
`;
